import React from 'react';

const Context = React.createContext('appurl');
export default Context;



// WEBPACK FOOTER //
// ./src/comparison-new/context.js